import { api } from "_shared/_stores/api";
import { logSchemaFailure } from "_shared/_utilities/log-schema-failure";
import type Session from "users/__session/session";
import {
  TutorialPreferencesSchema,
  type TutorialCueState,
  type TutorialPreferencesJSON,
} from "_shared/tutorials/_schemas/tutorial-preferences-schema";

type TutorialCueRequest = {
  tutorialId: string;
  cueId: string;
  contentVersion: number;
  state: TutorialCueState;
};

export const tutorialPreferencesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getTutorialPreferences: build.query<TutorialPreferencesJSON, { session: Session }>({
      query: ({ session }) => ({
        url: "users/me/tutorial-preferences",
        headers: { Authorization: `Bearer ${session.authToken?.value}` },
      }),
      rawResponseSchema: TutorialPreferencesSchema,
      onSchemaFailure: logSchemaFailure,
      providesTags: [{ type: "TutorialPreferences", id: "ME" }],
    }),
    updateTutorialPreferences: build.mutation<TutorialPreferencesJSON, { session: Session; enabled: boolean }>({
      query: ({ enabled }) => ({
        url: "users/me/tutorial-preferences",
        method: "PATCH",
        body: { enabled },
      }),
      rawResponseSchema: TutorialPreferencesSchema,
      onSchemaFailure: logSchemaFailure,
      invalidatesTags: [{ type: "TutorialPreferences", id: "ME" }],
    }),
    saveTutorialCue: build.mutation<TutorialPreferencesJSON, { session: Session; cue: TutorialCueRequest }>({
      query: ({ cue }) => ({
        url: "users/me/tutorial-preferences/cues",
        method: "PUT",
        body: cue,
      }),
      rawResponseSchema: TutorialPreferencesSchema,
      onSchemaFailure: logSchemaFailure,
      invalidatesTags: [{ type: "TutorialPreferences", id: "ME" }],
    }),
    resetTutorialCues: build.mutation<TutorialPreferencesJSON, { session: Session }>({
      query: () => ({
        url: "users/me/tutorial-preferences/cues",
        method: "DELETE",
      }),
      rawResponseSchema: TutorialPreferencesSchema,
      onSchemaFailure: logSchemaFailure,
      invalidatesTags: [{ type: "TutorialPreferences", id: "ME" }],
    }),
  }),
});

export const {
  useGetTutorialPreferencesQuery,
  useUpdateTutorialPreferencesMutation,
  useSaveTutorialCueMutation,
  useResetTutorialCuesMutation,
} = tutorialPreferencesApi;
